import React, { useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { useNavigate } from "react-router-dom";
import L from "leaflet";

function priceIcon(p) {
  return L.divIcon({
    className: "",
    html: `<div class="price-pin ${p.featured ? "featured" : ""}">${p.price_display}</div>`,
    iconSize: [0, 0],
    iconAnchor: [30, 14],
  });
}

function FitBounds({ points }) {
  const map = useMap();
  React.useEffect(() => {
    if (points.length > 0) {
      const bounds = L.latLngBounds(points.map((p) => [p.lat, p.lng]));
      map.fitBounds(bounds.pad(0.2), { maxZoom: 13 });
    }
  }, [points, map]);
  return null;
}

export function PropertyMap({ properties = [], center = [17.385, 78.4867], zoom = 11, height = "100%" }) {
  const navigate = useNavigate();
  const points = useMemo(() => properties.filter((p) => p.lat && p.lng), [properties]);

  return (
    <MapContainer center={center} zoom={zoom} style={{ height, width: "100%" }} scrollWheelZoom data-testid="property-map">
      <TileLayer
        attribution='&copy; OpenStreetMap'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <FitBounds points={points} />
      {points.map((p) => (
        <Marker key={p.id} position={[p.lat, p.lng]} icon={priceIcon(p)}>
          <Popup>
            <div className="w-56" data-testid={`map-popup-${p.id}`}>
              <div className="relative">
                <img src={p.images?.[0]} alt={p.title} className="w-full h-28 object-cover rounded-lg mb-2" />
                {p.featured && (
                  <span className="absolute top-1.5 left-1.5 px-2 py-0.5 rounded-full text-[10px] font-extrabold tracking-wider bg-gradient-to-r from-[#E7C56A] to-[#A8863A] text-[#0E3B2E] shadow" data-testid={`map-boosted-${p.id}`}>★ BOOSTED</span>
                )}
              </div>
              <div className="font-heading font-bold text-base text-slate-900">{p.price_display}</div>
              <div className="text-sm font-medium text-slate-800 line-clamp-1">{p.title}</div>
              <div className="text-xs text-slate-500 mb-2">{p.locality}, {p.city}</div>
              <button onClick={() => navigate(`/property/${p.id}`)}
                className="w-full bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold py-1.5 rounded-lg">
                View Details
              </button>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
